import React from 'react';
import './Login.css';
import { Alert, Col, Form as ReactForm, Button, Row } from 'react-bootstrap';
import { ErrorMessage, Form, Formik, FormikProps } from 'formik';
import * as Yup from 'yup';
import { ExternalContainer } from '../common/ExternalContainer';
import { FormControlError } from '../form/FormControlError';
import { useSelector } from 'react-redux';
import { AppState } from '../store/store';
import { Navigate } from 'react-router-dom';
import { useSubmitTwoFactorLoginForm } from './authHooks';
import { InternalNavigation } from '../navigation/helper';

const validationSchema = Yup.object().shape({
  otp: Yup.number().required('Required'),
});

export interface TwoFactorLoginFormValues {
  otp: string;
}

const initialValues: TwoFactorLoginFormValues = {
  otp: '',
};

export function TwoFactorLogin() {
  const { submitTwoFactorLoginForm } = useSubmitTwoFactorLoginForm();

  const { mfaToken, tokenResponse } = useSelector((state: AppState) => state.auth);
  if (!mfaToken && !tokenResponse?.accessToken) {
    return <Navigate to={{ pathname: InternalNavigation.login }} />;
  }

  return (
    <ExternalContainer>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={submitTwoFactorLoginForm}>
        {({ status, isSubmitting, errors, touched, values, handleChange }: FormikProps<TwoFactorLoginFormValues>) => (
          <Form noValidate>
            <ReactForm.Group as={Row} controlId='otp' className='form-group'>
              <Col md={3}>
                <ReactForm.Label column className='text-end'>
                  2FA
                </ReactForm.Label>
              </Col>

              <Col md={6}>
                <ReactForm.Control
                  type='text'
                  name='otp'
                  placeholder='Two Factor Code'
                  value={values.otp}
                  onChange={handleChange}
                  isInvalid={touched.otp && !!errors.otp}
                />
              </Col>

              <Col md={3}>
                <ErrorMessage name='otp' render={(message) => <FormControlError error={message} />} />
              </Col>
            </ReactForm.Group>

            <ReactForm.Group as={Row} className='form-group'>
              <Col md={{ offset: 3, span: 6 }} className='text-center'>
                <Button variant='primary' type='submit' disabled={isSubmitting}>
                  Sign in
                </Button>
              </Col>
            </ReactForm.Group>

            <Row>
              <Col md={{ offset: 3, span: 6 }}>{status && <Alert variant='danger'>{status}</Alert>}</Col>
            </Row>
          </Form>
        )}
      </Formik>
    </ExternalContainer>
  );
}

export default TwoFactorLogin;
